/**
 * StepNotSucceedNorFailedConditionType - Condition qui vérifie si une étape n'a ni réussi ni échoué
 * Identique à Java StepNotSucceedNorFailedCondition
 */

import {ConditionType} from '../types/ConditionType';
import {GameState} from '../../../models/GameState';
import {PlayerStep} from '../../../models/PlayerStep';
import GameRegistry from '../../GameRegistry';
import {StepType} from '../../types/StepType';

export class StepNotSucceedNorFailedConditionType implements ConditionType {
  typeName = 'COND_STEP_NOT_SUCCEED_NOR_FAILED';
  messageKey = 'laventurier.condition.not.succeed.nor.failed.name';
  descriptionKey = 'laventurier.condition.not.succeed.nor.failed.desc';
  errorKey = 'laventurier.condition.not.succeed.nor.failed.error';
  hasValue = false;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any, currentStep?: PlayerStep): boolean {
    // Si currentStep n'est pas fourni, utiliser l'étape courante du gameState
    const step = currentStep || (gameState.data.currentStepNumber ? {
      numero: gameState.data.currentStepNumber,
      type: '',
    } as PlayerStep : null);

    if (!step) {
      console.log('[StepNotSucceedNorFailedConditionType] FALSE: no current step');
      return false;
    }

    // Vérifier si l'étape courante n'a ni réussi ni échoué en utilisant le StepType
    try {
      const stepTypeName = step.type || 'STEP_SIMPLE';
      const stepType = GameRegistry.getStepType(stepTypeName) as StepType | undefined;
      
      let hasSucceeded = false;
      let hasFailed = false;

      if (stepType) {
        if (stepType.checkSuccess) {
          hasSucceeded = stepType.checkSuccess(gameState, step);
        }
        if (stepType.checkFailed) {
          hasFailed = stepType.checkFailed(gameState, step);
        }
      }

      // Fallback: vérifier le type de l'étape et le gameState
      if (!hasSucceeded && !hasFailed) {
        const stepTypeUpper = stepTypeName.toUpperCase();
        hasSucceeded = stepTypeUpper === 'STEP_SUCCEED' || stepTypeUpper === 'SUCCEED' || gameState.state === 'SUCCEED';
        hasFailed = stepTypeUpper === 'STEP_FAILED' || stepTypeUpper === 'FAILED' || gameState.state === 'FAILED';
      }

      const result = !hasSucceeded && !hasFailed;
      console.log(`[StepNotSucceedNorFailedConditionType] ${result ? 'TRUE' : 'FALSE'}: step ${step.numero} hasSucceeded=${hasSucceeded}, hasFailed=${hasFailed}`);
      return result;
    } catch (error) {
      console.error('[StepNotSucceedNorFailedConditionType] Error evaluating condition:', error);
      return false;
    }
  }
}
